const footer = {
  headline: "You're welcome. ;)",
  text:
    '<p><strong>Disclaimer:</strong> We are not psychologists or doctors. We are Prick experts. This is meant to increase your odds for a successful relationship; however, we cannot guarantee the success of any relationship. We are not held liable for any consequence of your results. You are free to use your results in any way you choose. By taking the quiz, you agree to these terms.</p><p>I mean, honestly, if they did give college credit for Prick experience, we’d definitely have our Masters by now. :|</p>',
  substack:
    '<p>Tired of falling for Pricks? Learn how to spot them. <a href="https://prickpredictor.substack.com/p/the-prick-papers" target="_blank" rel="noopener noreferrer">Read The Prick Papers on Substack.</a></p>',
  socialLinks: [
    {
      text: 'The Prick Papers',
      href: 'https://prickpredictor.substack.com/p/the-prick-papers',
      icon: 'SUBSTACK',
    },
    {
      text: 'Follow us',
      href: 'https://www.instagram.com/prickpredictor/',
      icon: 'INSTAGRAM',
    },
    {
      text: 'hello@prickpredictor.com',
      href: 'mailto:hello@prickpredictor.com',
      icon: 'MAIL',
    },
  ],
  privacyPolicy: 'Privacy policy',
  copyright: '© MMXXV Prick Predictor',
};

export default footer;



// WEBPACK FOOTER //
// ./src/locales/footer.js